import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';
import Layout from '@/components/Layout';
import Home from '@/pages/Home';
import Goldankauf from '@/pages/services/Goldankauf';
import Silberankauf from '@/pages/services/Silberankauf';
import Uhrenankauf from '@/pages/services/Uhrenankauf';
import Schmuckankauf from '@/pages/services/Schmuckankauf';
import Diamantenankauf from '@/pages/services/Diamantenankauf';
import CityPage from '@/pages/CityPage';
import FAQ from '@/pages/FAQ';
import Bewertungen from '@/pages/Bewertungen';
import Magazin from '@/pages/Magazin';
import Kontakt from '@/pages/Kontakt';
import Impressum from '@/pages/Impressum';
import Datenschutz from '@/pages/Datenschutz';
import AGB from '@/pages/AGB';
import Standort from '@/pages/Standort';

const cities = [
  'aachen', 'bielefeld', 'bochum', 'bonn', 'bottrop', 'dortmund',
  'duisburg', 'duesseldorf', 'essen', 'gelsenkirchen', 'hagen',
  'hamm', 'herne', 'koeln', 'krefeld', 'leverkusen',
  'moenchengladbach', 'muelheim-an-der-ruhr', 'muenster', 
  'oberhausen', 'remscheid', 'solingen', 'wuppertal'
];

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="goldankauf" element={<Goldankauf />} />
          <Route path="silberankauf" element={<Silberankauf />} />
          <Route path="uhrenankauf" element={<Uhrenankauf />} />
          <Route path="schmuckankauf" element={<Schmuckankauf />} />
          <Route path="diamantenankauf" element={<Diamantenankauf />} />
          {cities.map((city) => (
            <Route 
              key={city} 
              path={`ankauf-${city}`} 
              element={<CityPage citySlug={city} />} 
            />
          ))}
          <Route path="faq" element={<FAQ />} />
          <Route path="bewertungen" element={<Bewertungen />} />
          <Route path="magazin" element={<Magazin />} />
          <Route path="kontakt" element={<Kontakt />} />
          <Route path="standort" element={<Standort />} />
          <Route path="impressum" element={<Impressum />} />
          <Route path="datenschutz" element={<Datenschutz />} />
          <Route path="agb" element={<AGB />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}

export default App;